import { render } from "./ClawView.vue?vue&type=template&id=5d7e4192"
import script from "./ClawView.vue?vue&type=script&lang=js"
export * from "./ClawView.vue?vue&type=script&lang=js"

import "./ClawView.vue?vue&type=style&index=0&id=5d7e4192&lang=css"

import exportComponent from "/Users/peterdevos/Sites/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__